import { gql } from '@apollo/client';

export const WEBSITE_ADMIN_CONTENT_FIELDS = gql`
  fragment WebsiteAdminContentFields on WebsiteAdminContentType {
    id
    slug
    publicUrl
    status
    hasUnpublishedChanges
    draftHash
    displayDate
    scheduledAt
    scheduleFailureReason
    firstPublishedAt
    lastPublishedAt
    updatedAt
    updatedBy
    updatedByName
  }
`;

/** 操作名 WebsiteContentAdminList 在 XSS 白名单中（搜索词可能含 select … from），不能改名 */
export const WEBSITE_CONTENT_ADMIN_LIST = gql`
  query WebsiteContentAdminList(
    $status: WebsiteContentStatusEnum
    $contentType: WebsiteContentTypeEnum
    $keyword: String
    $sortBy: WebsiteContentAdminSortEnum
    $page: Int
    $pageSize: Int
    $lang: WebsiteContentLangEnum
  ) {
    websiteContentAdminList(
      status: $status
      contentType: $contentType
      keyword: $keyword
      sortBy: $sortBy
      page: $page
      pageSize: $pageSize
      lang: $lang
    ) {
      total
      scheduleFailedCount
      statusCounts {
        status
        count
      }
      items {
        contentType
        title
        coverThumbnailUrl
        content {
          ...WebsiteAdminContentFields
        }
      }
    }
  }
  ${WEBSITE_ADMIN_CONTENT_FIELDS}
`;

export const WEBSITE_CONTENT_ADMIN_DETAIL = gql`
  query WebsiteContentAdminDetail($id: Long!) {
    websiteContentAdminDetail(id: $id) {
      content {
        ...WebsiteAdminContentFields
      }
      contentType
      coverMediaId
      coverAlt
      videoMediaId
      videoDurationSeconds
      posterMediaId
      manualDisplayDate
      localizations {
        lang
        title
        summary
        bodyJson
        bodyUpdatedAt
      }
      attachments {
        mediaId
        displayName
        sortOrder
        url
        fileName
        sizeBytes
      }
      media {
        mediaId
        mediaType
        url
        mimeType
        width
        height
        srcset {
          url
          width
        }
      }
    }
  }
  ${WEBSITE_ADMIN_CONTENT_FIELDS}
`;

export const WEBSITE_CONTENT_DELETED_LIST = gql`
  query WebsiteContentDeletedList($page: Int, $pageSize: Int, $lang: WebsiteContentLangEnum) {
    websiteContentDeletedList(page: $page, pageSize: $pageSize, lang: $lang) {
      total
      items {
        id
        slug
        title
        coverThumbnailUrl
        status
        deletedAt
        deletedByName
      }
    }
  }
`;

export const WEBSITE_MEDIA_ITEM_FIELDS = gql`
  fragment WebsiteMediaItemFields on WebsiteMediaItemType {
    id
    mediaType
    fileName
    mimeType
    sizeBytes
    width
    height
    durationSeconds
    url
    thumbnailUrl
    srcset {
      url
      width
    }
    referencedCount
    createdAt
  }
`;

/** 媒体库（文件名搜索不在 XSS 白名单：文件名少见 select … from，被拦时提示修改） */
export const WEBSITE_MEDIA_LIST = gql`
  query WebsiteMediaList(
    $mediaType: WebsiteMediaTypeEnum
    $keyword: String
    $unreferencedOnly: Boolean
    $page: Int
    $pageSize: Int
  ) {
    websiteMediaList(
      mediaType: $mediaType
      keyword: $keyword
      unreferencedOnly: $unreferencedOnly
      page: $page
      pageSize: $pageSize
    ) {
      total
      items {
        ...WebsiteMediaItemFields
      }
    }
  }
  ${WEBSITE_MEDIA_ITEM_FIELDS}
`;

export const WEBSITE_CONTENT_OPERATION_LOGS = gql`
  query WebsiteContentOperationLogs(
    $objectType: WebsiteLogObjectTypeEnum!
    $operationType: WebsiteLogOperationTypeEnum
    $operatorId: Long
    $startTime: String
    $endTime: String
    $page: Int
    $pageSize: Int
  ) {
    websiteContentOperationLogs(
      objectType: $objectType
      operationType: $operationType
      operatorId: $operatorId
      startTime: $startTime
      endTime: $endTime
      page: $page
      pageSize: $pageSize
    ) {
      total
      items {
        id
        operatedAt
        operatorId
        operatorName
        operationType
        objectType
        objectId
        objectName
        slug
        ip
        scheduledBy
        description
      }
    }
  }
`;

export const WEBSITE_CONTENT_SITE_URL = gql`
  query WebsiteContentSiteUrl {
    websiteContentSiteUrl
  }
`;
